export default __webpack_public_path__ + "static/media/cold.ecfae21b.svg";